/**
 * 産廃回収詳細 連絡番号編集
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections`

const order_collection_verify_contact_number = {
  namespaced: true,
  actions: {
    /**
     * 変更確認
     * @param commit
     * @param order_id { number }
     * @param manifest_id { number }
     * @param params { Object }
     * @return {Promise<unknown>}
     */
    update ({ commit }, { order_id, manifest_id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${order_id}/verifies/contact_numbers/${manifest_id}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
  },
}
export default order_collection_verify_contact_number
